import { Button } from '@unified-checkout/design-system';
import { CircleExclamation } from '@unified-checkout/design-system/icons/index';
import { Tooltip } from 'libs/design-system/src/components/Tooltip';
import { FormatCurrencyForDisplay } from 'libs/design-system/src/utils/FormatCurrencyForDisplay';
import { useLangStore } from '@app/dashboard/store/lang';
import type { IBalancesDetailsProps } from '@app/dashboard/types/innerLayout/balances-details';
import { formatAmount } from '../../../views/pages/inner_layout/Balance/utils';
import styles from './balances-details.module.scss';

export const BalancesDetails = ({
  title,
  hintText,
  amount,
  currency,
  btnProps
}: IBalancesDetailsProps) => {
  const { lang } = useLangStore();

  const formattedAmount = FormatCurrencyForDisplay(
    formatAmount(
      amount,
      currency,
      lang
    )
  );

  return (
    <div className={styles['balances']}>
      <div className={styles['balances__content']}>
        <div className={styles['balances__content__label']}>
          {title}

          {hintText &&
            <Tooltip hintText={hintText} centerArrow={true}>
              <div className={styles['balances__content__info-icon']}>
                {CircleExclamation}
              </div>
            </Tooltip>
          }

        </div>
        <div className={styles['balances__content__amount']}>
          {formattedAmount}
        </div>
      </div>

      <div className={styles['balances__actions']}>
        {btnProps && btnProps.map((btnProp, index) =>
          <Button {...btnProp} key={index} />
        )}
      </div>
    </div>
  );
}

